import { Component, OnInit } from '@angular/core';
import { MenuService } from '@core';
import { Pagearray} from '../../../pagesarray';
import {TabService} from '../tabsmenu/tabservice';
import { Tab } from "../tabsmenu/tabmodel";
import { AuthService } from 'app/auth-guard/auth.service';
@Component({
  selector: 'app-topmenu',
  templateUrl: './topmenu.component.html',
})
export class TopmenuComponent implements OnInit {
  mainarray = [];

  constructor(public menuService: MenuService,public tabService:TabService,private authservice:AuthService) {
    
    if(this.authservice.getstoragedtl().user_role == 'PC')
    {
      this.mainarray.push({
        "state": "menu",
        "name": 'Create Booking',
        "type": "link",
        "icon": '',
        "accessstring": "1|0|0|0|0|0|1",
        "tableid":1,
        });
    }
    else{
      this.loadmenu();
    }
      
  }

  ngOnInit() {}
  loadmenu()
  {
    var roleid = this.authservice.getstoragedtl().roleid;
    var iconarr = ['dashboard','assignment','build','map','edit','person']
    this.authservice.selectdata('rolefilegenerate', { roleid : roleid}).subscribe((resp:any) =>
    {
      var data = resp;
      var parentarray = [] ;
      for (var i=0 ; i<data.length ; i++)
      {
          if(data[i].app_parent_id ==  null )
          {
              parentarray.push(data[i].app_page_id) ;
          }
      }
      if(parentarray.length > 0)
      {
          for (var j=0 ; j<parentarray.length ; j++)
          {
              var childarray = [];
              var parenturl = '' , parentname = '' ,parenticon = '' , parentaccessid = 0 ,parentaccessstring = '' ,parenttableid = '',parentmenupageid = '';
              for(var k=0 ; k<data.length ; k++)
              {
                  var childobject = {};
                  if(Pagearray.findIndex(x=>x.compname.trim() == data[k].app_menu_item.trim()) > -1 )
                  {
                  if( data[k].app_parent_id == parentarray[j] )
                  {
                    childobject = {
                      name : data[k].app_menu_item ,
                      url : data[k].app_page_name ,
                      icon : data[k].app_menu_icon ,
                      accessid : data[k].app_role_dtl ,
                      accessstring : data[k].accessblestring ,
                      tableid : data[k].tableid ,
                      menupageid : data[k].app_page_id ,
                    };
                    childarray.push(childobject);
                  }
                }
                  if( data[k].app_page_id == parentarray[j] )
                  {
                      parenturl = data[k].app_page_name ;
                      parentname = data[k].app_menu_item ;
                      parenticon = data[k].app_menu_icon ;
                      parentaccessid = data[k].app_role_dtl ;
                      parentaccessstring = data[k].accessblestring ;
                      parenttableid = data[k].tableid ;
                      parentmenupageid = data[k].app_page_id ;
                  }
              }
              
              if(childarray.length > 0)
              {
                var indx = this.mainarray.length;
                this.mainarray.push({
                  "state": "menu",
                  "name": parentname,
                  "type": "sub",
                  "icon": iconarr[Math.floor(Math.random()*iconarr.length)],
                  "accessstring":parentaccessstring,
                  "tableid":parenttableid,
                  "children": []
                  });
                  for(var m=0 ; m<childarray.length ; m++)
                  {
                    this.mainarray[indx].children.push({
                      "state": "menu",
                      "name": childarray[m].name,
                      "type": "link",
                      "accessstring":childarray[m].accessstring,
                      "tableid":childarray[m].tableid,
                    });
                  }
                 
              }
              // else
              // {  
              //   this.mainarray.push({
              //     "state": "menu",
              //     "name": parentname,
              //     "type": "link",
              //     "icon": iconarr[Math.floor(Math.random()*iconarr.length)],
              //     "accessstring":parentaccessstring,
              //     "tableid":parenttableid,
              //     });
             
              // }

          }
      }
      console.log(this.mainarray);
      // this.menus = this.mainarray;
    },
    onerror => 
    {
      console.log("Error man"); 
      this.loadmenu();

    });
  }
 
  buildtab(menudtl)
  {
    var indx = Pagearray.findIndex(x=>x.compname == menudtl.name.trim());
    if(indx > -1)
    {
      this.tabService.addTab(
        new Tab(Pagearray[indx].page, Pagearray[indx].compname,  menudtl )
        );
    }
    
    
  }
}
